"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dateFns = require("date-fns");

var _hooks = require("../../util/hooks");

require("./TimePicker.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var showWith0 = function showWith0(value) {
  return parseInt(value, 10) < 10 ? '0' + value : value.toString().slice(-2);
};

var LABELS = {
  en: {
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  },
  es: {
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos'
  },
  pt: {
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos'
  }
};

var TimePicker = function TimePicker(_ref) {
  var time = _ref.time,
      onChange = _ref.onChange,
      withSeconds = _ref.withSeconds,
      label = _ref.label,
      min = _ref.min,
      max = _ref.max,
      error = _ref.error,
      lang = _ref.lang;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      showHour = _useState2[0],
      setShowHour = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      showMinute = _useState4[0],
      setShowMinute = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      showSeconds = _useState6[0],
      setShowSeconds = _useState6[1];

  var formatHour = function formatHour(value) {
    return showHour !== null ? '' + showHour : showWith0(value);
  };

  var formatMinutes = function formatMinutes(value) {
    return showMinute !== null ? '' + showMinute : showWith0(value);
  };

  var formatSeconds = function formatSeconds(value) {
    return showSeconds !== null ? '' + showSeconds : showWith0(value);
  };

  var showRealHour = function showRealHour() {
    setShowHour(null);
    setShowMinute(null);
    setShowSeconds(null);
    setFocused(null);
  };

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      focused = _useState8[0],
      setFocused = _useState8[1];

  var focusOnHours = function focusOnHours() {
    return setFocused('HOURS');
  };

  var focusOnMinutes = function focusOnMinutes() {
    return setFocused('MINUTES');
  };

  var focusOnSeconds = function focusOnSeconds() {
    return setFocused('SECONDS');
  };

  var parentRef = (0, _react.useRef)(null);
  (0, _hooks.useOutsideClick)(parentRef, function () {
    return setFocused(null);
  });

  var limitedTime = function limitedTime(date) {
    if (min && date < min) {
      return setSecondsWrapper(min);
    }

    if (max && date > max) {
      return setSecondsWrapper(max);
    }

    return setSecondsWrapper(date);
  };

  var setSecondsWrapper = function setSecondsWrapper(val) {
    return withSeconds ? val : (0, _dateFns.setSeconds)(val, 0);
  };

  var hoursUp = function hoursUp() {
    return onChange(limitedTime((0, _dateFns.addHours)(time || (0, _dateFns.startOfToday)(), 1)));
  };

  var hoursDown = function hoursDown() {
    return onChange(limitedTime((0, _dateFns.subHours)(time || (0, _dateFns.startOfToday)(), 1)));
  };

  var minutesUp = function minutesUp() {
    return onChange(limitedTime((0, _dateFns.addMinutes)(time || (0, _dateFns.startOfToday)(), 1)));
  };

  var minutesDown = function minutesDown() {
    return onChange(limitedTime((0, _dateFns.subMinutes)(time || (0, _dateFns.startOfToday)(), 1)));
  };

  var secondsUp = function secondsUp() {
    return onChange(limitedTime((0, _dateFns.addSeconds)(time || (0, _dateFns.startOfToday)(), 1)));
  };

  var secondsDown = function secondsDown() {
    return onChange(limitedTime((0, _dateFns.subSeconds)(time || (0, _dateFns.startOfToday)(), 1)));
  };

  var handleHoursInputChange = function handleHoursInputChange(e) {
    if (e.target.value) {
      var value = parseInt(e.target.value, 10);
      if (isNaN(value) || value < 0 || value > 23) return;
      setShowHour(value <= 2 ? value : null);
      onChange(limitedTime((0, _dateFns.setHours)(time || (0, _dateFns.startOfToday)(), value)));
    } else {
      setShowHour(0);
      onChange(limitedTime(time ? (0, _dateFns.setHours)(time, 0) : (0, _dateFns.startOfToday)()));
    }
  };

  var handleMinutesInputChange = function handleMinutesInputChange(e) {
    if (e.target.value) {
      var value = parseInt(e.target.value, 10);
      if (isNaN(value) || value < 0 || value > 59) return;
      var theTime = time || (0, _dateFns.startOfToday)();
      setShowMinute(value === 0 || value === 1 || value <= 5 && Math.abs(theTime.getMinutes() - value) !== 1 ? value : null);
      onChange(limitedTime((0, _dateFns.setMinutes)(theTime, value)));
    } else {
      setShowMinute(0);
      onChange(limitedTime(time ? (0, _dateFns.setMinutes)(time, 0) : (0, _dateFns.startOfToday)()));
    }
  };

  var handleSecondsInputChange = function handleSecondsInputChange(e) {
    if (e.target.value) {
      var value = parseInt(e.target.value, 10);
      if (isNaN(value) || value < 0 || value > 59) return;
      var theTime = time || (0, _dateFns.startOfToday)();
      setShowSeconds(value === 0 || value === 1 || value <= 5 && Math.abs(theTime.getSeconds() - value) !== 1 ? value : null);
      onChange(limitedTime((0, _dateFns.setSeconds)(theTime, value)));
    } else {
      setShowSeconds(0);
      onChange(limitedTime(time ? (0, _dateFns.setSeconds)(time, 0) : (0, _dateFns.startOfToday)()));
    }
  };

  var onHoursKeyDown = function onHoursKeyDown(e) {
    if (e.keyCode === 38) {
      //Arrow Up
      hoursUp();
      e.preventDefault();
    } else if (e.keyCode === 40) {
      //Arrow Down
      hoursDown();
      e.preventDefault();
    }
  };

  var onMinutesKeyDown = function onMinutesKeyDown(e) {
    if (e.keyCode === 38) {
      //Arrow Up
      minutesUp();
      e.preventDefault();
    } else if (e.keyCode === 40) {
      //Arrow Down
      minutesDown();
      e.preventDefault();
    }
  };

  var onSecondsKeyDown = function onSecondsKeyDown(e) {
    if (e.keyCode === 38) {
      //Arrow Up
      secondsUp();
      e.preventDefault();
    } else if (e.keyCode === 40) {
      //Arrow Down
      secondsDown();
      e.preventDefault();
    }
  };

  var timeRef = (0, _hooks.useLatest)(time);
  (0, _hooks.useUpdateEffect)(function () {
    if (min && timeRef.current) {
      if (timeRef.current < min) onChange(limitedTime(timeRef.current));
    }
  }, [min]);
  (0, _hooks.useUpdateEffect)(function () {
    if (max && timeRef.current) {
      if (timeRef.current > max) onChange(limitedTime(timeRef.current));
    }
  }, [max]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-timepicker' + (error ? ' error' : ''),
    ref: parentRef
  }, label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-tp-label"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-timepicker-select' + (focused === 'HOURS' ? ' focused' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-input-container"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    pattern: "[0-9]*",
    className: "gcl-tp-input",
    value: time ? formatHour(time.getHours()) : '00',
    onChange: handleHoursInputChange,
    onKeyDown: onHoursKeyDown,
    onFocus: focusOnHours,
    onBlur: showRealHour
  }), /*#__PURE__*/_react["default"].createElement("span", null, LABELS[lang].hours)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-buttons"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron-up",
    tabIndex: -1,
    onClick: hoursUp,
    onMouseDown: focusOnHours,
    onFocus: focusOnHours,
    onBlur: function onBlur() {
      return setFocused(null);
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron",
    tabIndex: -1,
    onClick: hoursDown,
    onMouseDown: focusOnHours,
    onFocus: focusOnHours,
    onBlur: function onBlur() {
      return setFocused(null);
    }
  }))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-tp-select-colon"
  }, ":"), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-timepicker-select' + (focused === 'MINUTES' ? ' focused' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-input-container"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    pattern: "[0-9]*",
    className: "gcl-tp-input",
    value: time ? formatMinutes(time.getMinutes()) : '00',
    onChange: handleMinutesInputChange,
    onKeyDown: onMinutesKeyDown,
    onFocus: focusOnMinutes,
    onBlur: showRealHour
  }), /*#__PURE__*/_react["default"].createElement("span", null, LABELS[lang].minutes)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-buttons"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron-up",
    tabIndex: -1,
    onClick: minutesUp,
    onMouseDown: focusOnMinutes,
    onFocus: focusOnMinutes,
    onBlur: function onBlur() {
      return setFocused(null);
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron",
    tabIndex: -1,
    onClick: minutesDown,
    onMouseDown: focusOnMinutes,
    onFocus: focusOnMinutes,
    onBlur: function onBlur() {
      return setFocused(null);
    }
  }))), withSeconds && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-tp-select-colon"
  }, ":"), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-timepicker-select' + (focused === 'SECONDS' ? ' focused' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-input-container"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    pattern: "[0-9]*",
    className: "gcl-tp-input",
    value: time ? formatSeconds(time.getSeconds()) : '00',
    onChange: handleSecondsInputChange,
    onKeyDown: onSecondsKeyDown,
    onFocus: focusOnSeconds,
    onBlur: showRealHour
  }), /*#__PURE__*/_react["default"].createElement("span", null, LABELS[lang].seconds)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-tp-buttons"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron-up",
    tabIndex: -1,
    onClick: secondsUp,
    onMouseDown: focusOnSeconds,
    onFocus: focusOnSeconds,
    onBlur: function onBlur() {
      return setFocused(null);
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable chevron",
    tabIndex: -1,
    onClick: secondsDown,
    onMouseDown: focusOnSeconds,
    onFocus: focusOnSeconds,
    onBlur: function onBlur() {
      return setFocused(null);
    }
  }))))));
};

TimePicker.propTypes = {
  time: _propTypes["default"].instanceOf(Date),
  onChange: _propTypes["default"].func.isRequired,
  withSeconds: _propTypes["default"].bool,
  min: _propTypes["default"].instanceOf(Date),
  max: _propTypes["default"].instanceOf(Date),
  error: _propTypes["default"].bool,
  lang: _propTypes["default"].oneOf(['en', 'es', 'pt']).isRequired
};
TimePicker.defaultProps = {
  lang: 'en'
};
var _default = TimePicker;
exports["default"] = _default;